<template>
    <div class="card shadow"
         :class="type === 'dark' ? 'bg-default': ''">
        <div class="card-header border-0"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                        Standorte
                    </h3>
                </div>
                <div class="col text-right">
                    <base-button size="sm" type="secondary" @click="changePage(page)" icon="fas fa-sync-alt"></base-button>
                    <base-button v-if="isAdmin" type="primary" size="sm" v-on:click="$router.push('/locations/create')" icon="ni ni-fat-add"></base-button>
                </div>
            </div>
        </div>
        <div class="card-body" v-if="locationData.reportStatus === 'success'">
            <base-alert type="success">
                Der Bericht (ID: {{report.id}}) für den Standort <strong>{{report.location.name}}</strong> wurde erstellt.
                <base-button type="primary" size="sm" v-on:click="$router.push('/reports/show/'+report.id)">Bericht ansehen</base-button>
            </base-alert>
        </div>
        <div class="table-responsive">
            <base-table class="table align-items-center table-flush"
                        :class="type === 'dark' ? 'table-dark': ''"
                        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                        tbody-classes="list"
                        :data="tableData">
                <template slot="columns">
                    <th>id</th>
                    <TableHeadFilter v-if="isAdmin" title="Organisation" v-model="tableOptions.filter.customer" :has-filter="true" filter-type="dropdown" :dropdown-list="customers" @input="changePage(1)"></TableHeadFilter>
                    <TableHeadFilter title="Name" v-model="tableOptions.filter.name" :has-filter="true" filter-type="input" @input="changePage(1)"></TableHeadFilter>
                    <TableHeadFilter title="Straße" v-model="tableOptions.filter.street" :has-filter="true" filter-type="input" @input="changePage(1)"></TableHeadFilter>
                    <TableHeadFilter title="Stadt" v-model="tableOptions.filter.city" :has-filter="true" filter-type="input" @input="changePage(1)"></TableHeadFilter>
                    <TableHeadFilter v-if="isAdmin" title="Bundesland" v-model="tableOptions.filter.state" :has-filter="true" filter-type="dropdown" :dropdown-list="$store.getters['state/showStateCollection']" @input="changePage(1)"></TableHeadFilter>
                    <th>Abfragen</th>
                    <TableHeadFilter title="Nächstes Reporting" v-model="tableOptions.dateFilter.upcomingReportAt" :has-filter="true" :has-sort="true" filter-type="date"  @input="changePage(1)"><TableSortControl v-model="tableOptions.sort.upcomingReportAt" @input="changePage(1)"></TableSortControl> </TableHeadFilter>
                    <TableHeadFilter title="" v-model="tableOptions.filter.status" :has-filter="true" filter-type="dropdown" :dropdown-list="[{name: 'aktiv', id: 'active'},{name: 'inaktiv', id: 'inactive'}]" v-on:input="changePage(1)"></TableHeadFilter>
                    <th></th>
                </template>

                <template slot-scope="{row}">
                    <th scope="row">
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{row.id}}</div>
                    </th>
                    <td v-if="isAdmin">
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{(row.customer) ? row.customer.name : ''}}</div>
                    </td>
                    <td>
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{row.name}}</div>
                    </td>
                    <td>
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{row.street}}</div>
                    </td>
                    <td>
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{row.city}}</div>
                    </td>
                    <td v-if="isAdmin">
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{row.state.name }}</div>
                    </td>
                    <td>
                        <div v-if="isLoading" class="loading"> </div><div v-else><limits :location="row.id"></limits> </div>
                    </td>
                   <!--- <td>
                        <div v-if="isLoading" class="loading"> </div><div v-else>{{ row.tourintervall }} Sekunden</div>
                    </td> --->
                    <td>
                        <div v-if="isLoading" class="loading"> </div><div v-else><span v-if="row.isProtocolAllowed">{{ row.upcomingReportAt | formatDateToDay }}</span><span v-else>-</span></div>
                    </td>
                    <td>
                        <div v-if="isLoading" class="loading"> </div><div v-else><i class="fas fa-circle" :alt="row.status" :class="row.status === 'active' ? 'text-success' : 'text-danger'"></i></div>
                    </td>
                    <td class="text-right"><div v-if="isLoading" class="loading-button"> </div><div v-else>
                            <template>
                                <base-button v-on:click="$router.push('/locations/edit/'+row.id)" icon="fas fa-pencil-alt" type="primary" icon-only
                                              title="Ansehen und bearbeiten"></base-button>
                                <!---<base-button v-on:click="createReport(row.id)" :disabled="reportCreation.includes(row.id) || !row.isProtocolAllowed" :key="key" :icon="(reportCreation.includes(row.id)) ? 'fas fa-spinner fa-pulse' :'fas fa-file-alt'" type="primary" icon-only
                                              :title="(row.isProtocolAllowed) ? 'Bericht erstellen' : 'Upgraden Sie diesen Standort auf Premium, um Berichte erstellen zu können'"></base-button> -->
                                <base-button v-on:click="locationData.id = row.id" :disabled="reportCreation.includes(row.id) || !row.isReportAllowed" :key="key" :icon="(reportCreation.includes(row.id)) ? 'fas fa-spinner fa-pulse' :'fas fa-file-alt'" type="primary" icon-only
                                             :title="(row.isReportAllowed) ? 'Bericht erstellen' : 'Upgraden Sie diesen Standort auf Premium, um Berichte erstellen zu können'"></base-button>
                            </template></div>
                    </td>
                </template>
            </base-table>
        </div>

        <div class="card-footer d-flex justify-content-end"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <base-pagination :total="totalitems" v-on:input="changePage" :value="page"></base-pagination>
        </div>

        <ExportModal :location="locationData" :report-creation="reportCreation" :report="report"></ExportModal>

    </div>
</template>

<script>
    import ExportModal from "@/components/ExportModal";
    import TableHeadFilter from "@/components/TableHeadFilter";
    import TableSortControl from "@/components/TableSortControl";
    import Limits from "@/views/Locations/limits";
    export default {
        name: "list",
        components:{Limits, TableSortControl, TableHeadFilter, ExportModal},
        props: {
            type: {
                type: String
            },
            title: String
        },
        data() {
            return {
                tableOptions: {
                    filter: {
                        customer: null,
                        name: null,
                        street: null,
                        postalcode: null,
                        city: null,
                        state: null,
                        status: null
                    },
                    dateFilter: {
                        upcomingReportAt: null
                    },
                    sort:{
                        upcomingReportAt: null
                    }},
                tableData: [
                    {
                        id: 0,
                        name: "",
                        street: "",
                        postalcode: 0,
                        city: "",
                        status:	"",
                        tourintervall: 720,
                        upcomingReportAt: new Date(),
                        state: {
                            name: null
                        },
                        customer: {
                            name: null
                        }
                    }
                ],
                report: {
                    id: 0,
                    periodStartsAt: null,
                    periodEndsAt: null,
                    status: '',
                    location: null,
                    createdAt: null,
                    customer: null,
                    publicPath: '',
                },
                customerFilter: {active: false, customer: null},
                totalitems: 0,
                page: 1,
                isLoading: false,
                reportCreation: [],
                key: 11,
                locationData: { id: 0, reportStatus: null }
            }
        },
        created() {
          this.changePage(this.page);
          if (!this.$store.getters['country/isReady']) this.$store.dispatch('country/getCountryCollection');
          if (!this.$store.getters['state/isReady']) this.$store.dispatch('state/getStateCollection');
          if (!this.$store.getters['customer/isReady']) this.$store.dispatch('customer/getCustomerCollection');
        },
        computed: {
            isAdmin() {
                return this.$store.getters['authentication/isAdmin'];
            },
            customers() {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                return this.$store.getters['customer/showCustomerCollection'].sort((a, b) =>{
                    return a.name.localeCompare(b.name);
                });
            },
            customerFilterCustomer() {
                return this.customerFilter.customer;
            }
        },
        watch: {
            // whenever question changes, this function will run
            // eslint-disable-next-line no-unused-vars
            reportCreation: function (newReportCreation, oldReportCreation) {
                this.key++;
            },
            customerFilterCustomer: function () {
                this.changePage(this.page)
            }
        },
        methods: {
            changePage(page) {
                this.isLoading = true;
                this.getTableData(page).then(
                    response => {
                        this.tableData = response.member;
                        this.totalitems = response.totalItems;
                        this.page = page;
                        this.isLoading = false;
                    }
                )
            },
            getTableData(page){
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header
                    };

                    let url = process.env.VUE_APP_API_SERVER + `/api/locations?`+ this.getUrlExtension(this.tableOptions.filter,this.tableOptions.sort,this.tableOptions.dateFilter) + `&page=` + page;

                    fetch(url, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            resolve({
                                totalItems: response['hydra:totalItems'],
                                member: response['hydra:member']
                            });
                        }, error => {reject(error); });
                });
            },
            createReport(location) {
                this.reportStatus = "loading";
                return new Promise((resolve, reject) => {
                    this.reportCreation.push(location);
                    this.key++;
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header
                    };

                    fetch(process.env.VUE_APP_API_SERVER + `/report/create/` + location, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            this.report = response;
                            this.reportStatus = 'success';
                            this.$store.dispatch('alert/clear');
                            this.reportCreation.splice(this.reportCreation.indexOf(location),1);
                            this.key++;
                            resolve({
                                member: response
                            });
                        }, error => {
                            this.reportStatus = "error";
                            this.$store.dispatch('alert/error',error);
                            this.reportCreation.splice(this.reportCreation.indexOf(location),1);
                            this.key++;
                            reject(error); });
                });
            }
        }
    }
</script>

<style scoped>

</style>